import React, { useState } from "react";
import PropTypes from "prop-types";
import FilterCloseIcon from "../../assets/filter-close.svg";
import FilterselectIcon from "../../assets/filter-blue.svg";
import { Dropdown, Button, DatePicker } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

function DropdownFilterWithDateRangePickerInitialValue(props) {
  const { RangePicker } = DatePicker;
  const { text, isSortable, onReset, onApply,value } = props;
  const [filters, setFilters] = useState(() => {
    let intialFilters = {
      text: [],
    };
    return {
      isOpen: false,
      isAsc: true,
      isFilterBoxOpen: null,
      filters: intialFilters,
    };
  });

  let items = [];
const dateValues =  value?.filters?.text? value?.filters?.text:filters.filters.text || [];

  const sortableMenus = [
    {
      label: (
        <button
          onClick={(e) => {
            e.preventDefault();
            handleSort("asc");
          }}
          className={
            filters.isAsc ? "ats-filter-sort sort-active" : "ats-filter-sort"
          }
        >
          Sort ascending
          <ArrowUpOutlined />
        </button>
      ),
    },
    {
      type: "divider",
    },
    {
      label: (
        <button
          onClick={(e) => {
            e.preventDefault();
            handleSort("desc");
          }}
          className={
            !filters.isAsc ? "ats-filter-sort sort-active" : "ats-filter-sort"
          }
        >
          Sort descending
          <ArrowDownOutlined />
        </button>
      ),
    },
    {
      type: "divider",
    },
  ];

  const menus = [
    {
      label: (
        <div>
          <span className="font-face-vzw ats-filter-header">Filter</span>
        </div>
      ),
    },
    {
      label: (
        <RangePicker
          style={{
            width: "90%",
            height: "32px",
            marginTop: "5px",
            marginBottom: "5px",
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: "50px", // Circular edges
            paddingLeft: "10px", // Extra space to accommodate the icon
            display: "flex", // Use flexbox for horizontal alignment
            alignItems: "center", // Vertically center items
          }}
          format={'MM-DD-YYYY'}
          onChange={handleLastUpdatedFilterChange}
          value={dateValues.length ? [dayjs(dateValues[0]), dayjs(dateValues[1])] : []}
          allowClear={false}
        />
      ),
    },
    {
      label: (
        <div className="ats-filter-footer">
          <button onClick={handleReset} className="reset-filter">
            Reset filter
          </button>
          <Button
            onClick={handleApplyFilter}
            className="ats-filter-footer-button"
            color="default"
            variant="solid"
          >
            Apply
          </Button>
        </div>
      ),
    },
  ];

  if (isSortable) {
    items = [...sortableMenus, ...menus];
  } else {
    items = [...menus];
  }

  const handleSort = (val) => {
    if (val === "asc") {
      setFilters((prev) => ({ ...prev, isFilterBoxOpen: true, isAsc: true }));
    } else {
      setFilters((prev) => ({ ...prev, isFilterBoxOpen: true, isAsc: false }));
    }
  };

  function handleReset(e) {
    e.preventDefault();
    setFilters((prev) => {
      let filters = {
        text: [],
      };
      
      return { ...prev, isAsc: true, filters: filters, isFilterBoxOpen: true, isOpen: false};
    });
    onReset({ filters: filters.filters, isAsc: filters.isAsc });
  }

  function handleApplyFilter(e) {
    e.preventDefault();
    setFilters((prev) => ({ ...prev, isFilterBoxOpen: false, isOpen: false }));
    onApply({ filters: filters.filters, isAsc: filters.isAsc });
  }

  function handleLastUpdatedFilterChange(val){
    setFilters((prev) => ({
      ...prev,
      isFilterBoxOpen: true,
      filters: {
        ...prev.filters,
        text: val
      },
    }));
  };

  const handleOpenChange = (val) => {
    if (val === false) {
      if (filters?.isOpen === true) {
        setFilters((prev) => ({ ...prev, isFilterBoxOpen: null, isOpen: val }));
      }
    } else {
      setFilters((prev) => ({ ...prev, isOpen: val }));
    }
  };
  function isAnyFilterTrue(data) {
    return data.text.length !== 0;
  }

  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
      onOpenChange={handleOpenChange}
      open={filters.isOpen}
      overlayClassName="ats-filter-overlay"
    >
      <div className="ats-filter">
        <span className="font-face-vzw">{text}</span>
        <img
          src={
            filters.isOpen || isAnyFilterTrue(filters?.filters)|| value
              ? FilterselectIcon
              : FilterCloseIcon
          }
          alt="filter-icon"
        />
      </div>
    </Dropdown>
  );
}

DropdownFilterWithDateRangePickerInitialValue.propTypes = {
  text: PropTypes.string.isRequired,
  isSortable: PropTypes.bool,
  onReset: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
};

export default DropdownFilterWithDateRangePickerInitialValue;
